// 用户运营数据统计
export const dataStatisticsRouter = [
    //  引导弹窗数据统计
    {
        path: '/dataStatistics/guidePopup',
        name: 'guidePopupStatistics',
        component: () => import('../views/dataStatistics/guidePopup.vue')
    },
    // 26.2年闯关活动数据
    {
        path: '/dataStatistics/challengeActivity',
        name: 'challengeActivityStatistics',
        component: () => import('../views/dataStatistics/challengeActivity.vue')
    },
    // 七周年庆-活动统计
    {
        path: '/dataStatistics/sevenYearAnniversary',
        name: 'sevenYearAnniversary',
        component: () => import('../views/dataStatistics/sevenYearAnniversary.vue')
    },
    //答题活动榜单
     {
        path: '/dataStatistics/activelist',
        name: 'activelist',
        component: () => import('../views/dataStatistics/activelist.vue')
    },
    // 花名册活动数据
    {
        path: '/dataStatistics/rosterActivity',
        name: 'rosterActivity',
        component: () => import('../views/dataStatistics/rosterActivity.vue')
    }
]